var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useHistory } from "react-router-dom";
import qs from "qs";
import * as R from "ramda";
export var recoverValues = function (search) {
    return qs.parse(search.substring(1));
};
export var makeUrl = function (_a, values) {
    var _b = _a.location, pathname = _b.pathname, search = _b.search;
    var paramsValue = qs.parse(search.substring(1));
    var newParams = __assign(__assign({}, paramsValue), values);
    return pathname + "?" + qs.stringify(newParams, {
        filter: function (prefix, value) { return R.isEmpty(value) ? undefined : value; }
    });
};
var useQueryParams = function () {
    var history = useHistory();
    var push = function (values) {
        history.push(makeUrl(history, values));
    };
    var clear = function () {
        history.push(history.location.pathname);
    };
    return {
        initialValues: recoverValues(history.location.search),
        clear: clear,
        push: push,
    };
};
export default useQueryParams;
//# sourceMappingURL=useQueryParams.js.map